import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type {
  FeatureFlagRecord,
  UpdateFeatureFlagRequest,
} from "../FeatureFlagRecord";

import * as UseCheckFeatureFlag from "./useCheckFeatureFlag";
import * as UseFeatureFlags from "./useFeatureFlags";

interface UpdateFeatureFlagArgs {
  featureFlagId: string;
  updates: UpdateFeatureFlagRequest;
}

export function useUpdateFeatureFlag() {
  const { featureFlagService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<FeatureFlagRecord, Error, UpdateFeatureFlagArgs>({
    mutationFn: ({ featureFlagId, updates }) =>
      featureFlagService.update(featureFlagId, updates),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: UseFeatureFlags.getQueryKey(),
      });
      void queryClient.invalidateQueries({
        queryKey: UseCheckFeatureFlag.getQueryKey(),
      });
    },
  });
}
